import { ReactComponent as LogoApp } from '@svg/v2/logo_app.svg?react';

import { LoadingDots } from './loading-dots';

function FullPageLoader() {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-5 bg-background">
      <LogoApp
        className="h-14 w-14"
        style={{ animation: 'logo-pulse 2s ease-in-out infinite' }}
      />
      <LoadingDots size="default" className="text-muted-foreground" />
    </div>
  );
}

export { FullPageLoader };
